<router-outlet></router-outlet>
<ngx-spinner
  bdColor="rgba(0,0,0,0.8)"
  size="large"
  color="#d0a77b"
  type="ball-beat"
  [fullScreen]="true"
></ngx-spinner>